import { gql } from 'apollo-angular';

export const generateSearchResultsReportMutation = gql`
  mutation GenerateSearchResultsReportMutation ($searchResultsReport: SearchResultsReportInput!, $type: AsyncRequestTypeInput!) {
    generateSearchResultsReport (searchResultsReport: $searchResultsReport, type: $type)
  }
`;

export const generateCustomPathVariantsSearchReportMutation = gql`
  mutation GenerateCustomPathVariantsSearchReportMutation ($searchResultsReport: SearchResultsReportInput!) {
    generateCustomPathVariantsSearchReport (searchResultsReport: $searchResultsReport)
  }
`;
